import React from 'react'
import ProjectSession from "../../../model2/project/project-session";
import {EmojiDict} from "../../../gd/const/item-icon/emoji/emoji";
import Emoji from "../common/emoji/emoji";
import project_getIconClass from "../../../model2/project/actions/get-project-icon-class";
import {ItemIconSize} from "../@const";
import CustomIcon from "../common/custom-icon/custom-icon";

type Props = {
    className?  : string

    project?    : ProjectSession // | Project - it may be any model (i.e. passed to FieldProjectIcon_View)
    projectId?  : ID

    size?       : ItemIconSize
    colorize?   : boolean
    hint?       : boolean

    disabled?   : boolean            // new way to disable

    // need implementation
    isExpanded? : boolean     // if true replace folder with open-folder this is used in navigation menu and views like table

    // very special
    emojiFontSize?: number      // if passed it will use size for width / line height BUT increase emoji font size
}

// TUT fignya s size.... nado adekvatno podumat' sdelat'

export default function ProjectIconUI5(props:Props):any {

    // const size = _.get(props, 'size', '13')
    const size : ItemIconSize = _.get(props, 'size', ItemIconSize.SIZE_14) // new experimental vic

    // @ts-ignore
    let sessionProject : ProjectSession | null = props.projectId ? gd.session.projects.get(props.projectId) : props.project

    // patch to support templates
    // try check in tempaltes
    if (!sessionProject) {
        sessionProject = gd.session.templatesList.get(props.projectId)
    }

    /*// if no project found in session not in templates return false
    if (!sessionProject) {
        console.warn("ProjectIconUI5: no project in session")
        return false
    }*/

    // sessionProject.projectIcon = 'url:https://www.svgrepo.com/show/530597/hat.svg'
    // url:https://www.svgrepo.com/show/530597/hat.svg
    if (sessionProject?.projectIcon?.substring(0,4)==='url:') {
        return <CustomIcon size={size} className={props.className} icon={sessionProject.projectIcon} />
    }

    // EMOJI CASE
    if (!!EmojiDict[sessionProject?.projectIcon]) {

        // need add black and white fiulter when disabled ?
        const classes = Classes("ui5-project-icon", props.className)

        return <Emoji name={sessionProject.projectIcon} className={classes} size={size} />
    }

    // ICON CASE

    let colorClass : string | false = false
    if (props.colorize) {
        colorClass = 'gd-c-font-'+sessionProject?.color
    }

    let iconClass : string | boolean = sessionProject?.iconClass
        || project_getIconClass(sessionProject?.projectIcon) // in case project is not ProjectSession and has no iconClass getter
        || 'i5-project'

    // open folder patch
    if (
        props.isExpanded
        && iconClass === 'ii5-folder'
    ) {
        iconClass = 'ii5-folder-open'
    }

    // we keep gd-ui-project-icon class as legacy need remove it in future
    const classes = Classes(
        "gd-ui-project-icon", // old
        "ui5-project-icon", // new
        // "ui5-ico-"+size,
        "fs-"+size,
        iconClass, colorClass, props.className, {
            disabled: props.disabled,
        }
    )

    return <div className={classes}/>
}
